import { faker } from '@faker-js/faker';

import { coerceBoolean, objectValues, random } from '@hsp/utilities';

import { userRoles } from '@t/p/security/users/roles.enums';

import { IResult } from '@t/api';
import { IUserDashboard } from '@t/user/dashboard';

import { defaultMockTime, Uri } from 'constants/index';
import { BaseHttpService } from 'services/http';

class UserManageService extends BaseHttpService {
  constructor() {
    super({ endpoints: objectValues(Uri.User) as string[] });
  }

  getUsers(): Promise<IResult<IUserDashboard[]>> | undefined {
    return this.get({ url: Uri.User.Users });
  }
}
export const userManageService = new UserManageService();

if (coerceBoolean(process.env.REACT_APP_API_USER_FAKE)) {
  const mocked = userManageService.mock(defaultMockTime);
  const mock = mocked?.adapter;

  mock?.onGet(Uri.User.Users).reply((): Promise<[number, IResult<IUserDashboard[]>]> => {
    return new Promise((resolve) => {
      const data: IUserDashboard[] = [];

      Array.from({ length: random(50) }).forEach(() => {
        data.push({
          clientGroup: faker.word.noun(),
          department: faker.person.jobType(),
          email: faker.word.noun(),
          firstName: faker.person.firstName(),
          lastName: faker.person.lastName(),
          phoneNumber: faker.phone.number(),
          reporter: faker.person.fullName(),
          role: faker.helpers.enumValue(userRoles),
          userId: faker.string.uuid(),
        });
      });
      const result: IResult<IUserDashboard[]> = {
        dataContainer: data as unknown as IUserDashboard[],
        failure: false,
        statusCode: 200,
        success: true,
      };

      resolve([200, result]);
    });
  });
}
